import { render } from "./VideoComponents.vue?vue&type=template&id=0318804a"
import script from "./VideoComponents.vue?vue&type=script&lang=js"
export * from "./VideoComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__